// import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Button, Form } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import Select, { components } from 'react-select';
import deburr from 'lodash/deburr';
import { Row, Col } from 'react-bootstrap';
import logo from './Esboco_Logo_2025_Negativo.png'; // Modo claro
import logoDark from './Esboco_Logo_2025_Noturno.png';     // 🔥 Logo para modo noturno
import { useTheme } from '../context/ThemeContext';
import produtosPreCarregados from './produtos.json';
import { Spinner } from 'react-bootstrap';
import seloSeguro from './safe.png';
import { useCallback } from 'react';
import { Modal } from 'react-bootstrap';

const PDVApp = () => {

  const [productCode, setProductCode] = useState('');
  const [productOptionCode, setProductOptionCode] = useState('');
  // const [products, setProducts] = useState([]);
  const [products, setProducts] = useState(
    produtosPreCarregados.filter(p => p.amount && p.amount > 0)
  );
  const [quantity, setQuantity] = useState(1);
  const [value, setValue] = useState('');
  const [pixCode, setPixCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [codigoResgate, setCodigoResgate] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const selectRef = React.createRef();
  const [txId, setTxId] = useState('TxId81629');
  const [productImage, setProductImage] = useState('');
  const [nomeProdutoSelecionado, setNomeProdutoSelecionado] = useState('');
  const valorComDesconto = (parseFloat(value) - 0.01).toFixed(2);
  const [emailCliente, setEmailCliente] = useState('');
  const [tempoRestante, setTempoRestante] = useState(null);
  const [qrCodeExpirado, setQrCodeExpirado] = useState(false);
  const [amountAquipaga, setAmountAquipaga] = useState(null);
  const [logado, setLogado] = useState(false);
  const [exibirLogin, setExibirLogin] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const usuariosPermitidos = {
    "alan.pereira": "@d3f3ndY0U25",
    "monique.silva": "&C@tarina6"
  };

const gerarNumeroIntencaoCompra = () => {
  const ultima = localStorage.getItem('contadorIntencaoCompra') || '0';
  const novoNumero = parseInt(ultima, 10) + 1;
  localStorage.setItem('contadorIntencaoCompra', novoNumero);
  return `#${String(novoNumero).padStart(3, '0')}`;
};

const OptionWithImage = (props) => {
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {props.data.image && (
          <img 
            src={props.data.image} 
            alt={props.data.label} 
            style={{ width: 24, height: 24, marginRight: 10, borderRadius: 4 }} 
          />
        )}
        {props.data.label}
      </div>
    </components.Option>
  );
};

const SingleValueWithImage = (props) => {
  return (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {props.data.image && (
          <img 
            src={props.data.image} 
            alt={props.data.label} 
            style={{ width: 24, height: 24, marginRight: 10, borderRadius: 4 }} 
          />
        )}
        {props.data.label}
      </div>
    </components.SingleValue>
  );
};

const enviarEmailIntencaoCompra = async (produto, externalId, pixCopiaCola, numero) => {
  const timestamp = new Date().toLocaleString('pt-BR', { hour12: false });

  const subject = `💡 #app-giffi | Nova intenção de compra: ${produto}`;
  const text = `Timestamp: ${timestamp}
Produto: ${produto}
E-mail: ${emailCliente || 'Não informado'}
QR Code PIX gerado: ${pixCopiaCola}`;

  try {
    await axios.post('https://pdvapi.giffi.com.br/api/email-smtp', {
      to: 'loja@giffi.com.br',
      subject,
      text
    });
    console.log('📨 E-mail de intenção enviado com sucesso');
  } catch (error) {
    console.error('❌ Erro ao enviar e-mail de intenção:', error);
  }
};

const enviarEmailTransacional = async (produto, codigo, externalId, numeroIntencao, customSubject) => {
  const destinatarios = emailCliente
    ? `loja@giffi.com.br, ${emailCliente}`
    : "loja@giffi.com.br";

  const subject = customSubject || `✅ #app-giffi | Compra finalizada: ${produto}`;
  const text = `E-mail do cliente: ${emailCliente || 'não informado'}
External ID da transação: ${externalId}
Código gerado: ${codigo}`;

  try {
    await axios.post('https://pdvapi.giffi.com.br/api/email-smtp', {
      to: destinatarios,
      subject,
      text
    });
    console.log('📧 E-mail enviado com sucesso');
  } catch (error) {
    console.error('❌ Erro ao enviar e-mail:', error);
  }
};

const iniciarContagemRegressiva = () => {
  const duracaoInicial = 15 * 60; // 15 minutos em segundos
  setTempoRestante(duracaoInicial);
  setQrCodeExpirado(false);

  const timer = setInterval(() => {
    setTempoRestante(prev => {
  if (prev === 1) {
    clearInterval(timer);
    setQrCodeExpirado(true);
  }
  return prev - 1;
});
  }, 1000);
};

const handleCompraDireta = async () => {
  if (!selectedProduct) {
    alert("Selecione um produto para continuar.");
    return;
  }

  setLoading(true);
  setCodigoResgate(null);

  try {
    // 1. Solicita QR fixo e registra intenção
    const response = await fetch("https://pdvapi.giffi.com.br/api/comprar", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        value: selectedProduct.amount,
        productCode: selectedProduct.code,
        productOptionCode: selectedProduct.productOptionCode,
        nomeProduto: selectedProduct.name,
        email: emailCliente || null
      })
    });

    const { txId } = await response.json();
    console.log("🔄 Compra direta iniciada. Aguardando pagamento...");

    // 2. Faz polling até detectar saldo
    const maxTentativas = 30;
    let tentativa = 0;
    let pagamentoConfirmado = false;

    while (tentativa < maxTentativas) {
      await new Promise(resolve => setTimeout(resolve, 1000));

      const check = await fetch("https://pdvapi.giffi.com.br/api/consultar-saldo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ txId })
      });

      const checkData = await check.json();
      if (checkData.paid) {
        pagamentoConfirmado = true;
        break;
      }

      tentativa++;
    }

    if (!pagamentoConfirmado) {
      alert("Pagamento não foi detectado a tempo. Tente novamente.");
      return;
    }

    // 3. Executa a DoTransaction
    const transacao = await fetch("https://pdvapi.giffi.com.br/api/processar-pagamento", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        productOptionCode: selectedProduct.productOptionCode,
        quantity: 1,
        value: selectedProduct.amount,
        txId,
        amountOverride: selectedProduct.amount
      })
    });

const transacaoData = await transacao.json();
    setCodigoResgate(transacaoData.codigoResgate);
    console.log("✅ Código entregue:", transacaoData.codigoResgate);

// 🛠️ log para debug
  console.log("📧 Preparando envio de e-mail para Compra Direta:", {
    produto: selectedProduct.name,
    codigo: transacaoData.codigoResgate,
    txId,
    email: emailCliente
  });

    // ✅ Envia o e-mail transacional
    await enviarEmailTransacional(
      selectedProduct.name,
      transacaoData.codigoResgate,
      txId,
      null, // ignoramos o numeroIntencao
      `🎯 #app-giffi | Compra direta finalizada: ${selectedProduct.name}`
    );

  } catch (err) {
    console.error("Erro na compra direta:", err);
    alert("Ocorreu um erro ao finalizar a compra.");
  } finally {
    setLoading(false);
  }
};

const normalizeText = (text) => {
  return deburr(text)
    .toLowerCase()
    .replace(/r\$|\breais?\b|[^a-z0-9]/gi, '') // remove R$, "reais" e caracteres especiais
    .trim();
};

  // 🚀 Buscar produtos ao carregar a página
  useEffect(() => {
   axios.get('https://pdvapi.giffi.com.br/api/produtos')
     .then(response => {
       console.log("🚀 Produtos carregados do backend:", response.data); // <-- Verificar o que chega do backend
       setProducts(response.data);

     })
     .catch(error => console.error('Erro ao carregar produtos:', error));
 }, []);

// 🛡️ Proteger saída da página com envio de e-mail se QR Code ainda estiver válido
useEffect(() => {
  const enviarExpirado = () => {
    if (pixCode && !qrCodeExpirado && !codigoResgate) {
      const numero = localStorage.getItem(`numeroCompra-${txId}`) || '#????';
      const payload = {
        produto: nomeProdutoSelecionado,
        externalId: txId,
        pixCopiaCola: pixCode,
        numero,
        emailCliente
      };
      try {
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon('https://pdvapi.giffi.com.br/api/expirado', blob);
        console.log('📤 [sendBeacon] Enviado ao backend.');
      } catch (err) {
        console.error('❌ Falha no sendBeacon:', err);
      }
    }
  };

  document.addEventListener('visibilitychange', enviarExpirado);
  window.addEventListener('beforeunload', enviarExpirado);

  return () => {
    document.removeEventListener('visibilitychange', enviarExpirado);
    window.removeEventListener('beforeunload', enviarExpirado);
  };
}, [pixCode, qrCodeExpirado, txId, nomeProdutoSelecionado, emailCliente]);

const generateDynamicQRCode = async (tipo = 'br') => {
  try {
    console.log("💰 Valor enviado para o QR Code:", value);
    console.log(`🔍 URL sendo chamada: https://proxypix.giffi.com.br/api/v1 (tipo: ${tipo})`);

    const response = await axios.get('https://proxypix.giffi.com.br/api/v1', {
      params: {
        valor: valorComDesconto,
        chave: 'b111b091-dca4-4450-8394-b69a52d18124',
        txid: 'TxId81629',    // ✅ SEMPRE USA ESSE VALOR PARA O QR CODE!
        nome: 'aquipaga',
        cidade: 'saopaulo',
        saida: tipo
      }
    });

    console.log("📦 Resposta recebida da API:", response.data);

    if (tipo === 'br' && response.data.brcode) {
      const numero = gerarNumeroIntencaoCompra(); // ✅ Agora está definido

      localStorage.setItem(`numeroCompra-${txId}`, numero);
      setPixCode(response.data.brcode);
      setMessage('QR Code gerado. Aguardando pagamento...');
      iniciarContagemRegressiva();

      await enviarEmailIntencaoCompra(nomeProdutoSelecionado, txId, response.data.brcode, numero);
    } else if (tipo === 'qr' && response.data.imagem) {
      setPixCode(response.data.imagem);
      setMessage('QR Code gerado. Aguardando pagamento...');
    } else {
      console.error("❌ Resposta não contém o valor esperado!");
      setMessage('Erro ao gerar QR Code.');
    }
    
  } catch (error) {
    setMessage('Erro ao gerar QR Code.');
    console.error(error);
  }
};

const handlePurchase = async () => {
  if (!value || value <= 0) {
    setMessage('Valor do produto não foi definido corretamente.');
    console.error('Erro: Valor do produto não encontrado.');
    return;
  }

  setLoading(true);
  setMessage('');
  setCodigoResgate('');

  try {
    const response = await axios.post('https://pdvapi.giffi.com.br/api/comprar', {
      value,
      productCode,
      productOptionCode,
      nomeProduto: nomeProdutoSelecionado,
      email: emailCliente
    });

    const { pixCode, txId } = response.data;

    if (!pixCode || !txId) {
      throw new Error('Resposta do backend não trouxe pixCode ou txId.');
    }

    setTxId(txId);
    setPixCode(pixCode);
    setMessage('QR Code gerado. Aguardando pagamento...');
    iniciarContagemRegressiva();

    const numero = gerarNumeroIntencaoCompra();
    localStorage.setItem(`numeroCompra-${txId}`, numero);

    await enviarEmailIntencaoCompra(
      nomeProdutoSelecionado,
      txId,
      pixCode,
      numero
    );

    checkPaymentStatus(txId);

  } catch (error) {
    setMessage('Erro ao gerar QR Code.');
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const checkPaymentStatus = (txId) => {
  console.log(`🔍 Iniciando verificação de pagamento para TxId: ${txId}`);

  const interval = setInterval(async () => {
    try {
      console.log(`🔄 Consultando saldo para o TxId: ${txId}`);
      
      // ✅ Enviando a requisição para consultar o saldo
      const response = await axios.post('https://pdvapi.giffi.com.br/api/consultar-saldo', { txId });

      if (response.data.paid) {
        clearInterval(interval);
        console.log('✅ Pagamento confirmado, iniciando DoTransaction...');

        // ✅ Disparar o pagamento com o ExternalId correto
        await processarPagamento(txId);
      } else {
        console.log(`❌ Pagamento ainda não detectado para TxId ${txId}`);
      }
    } catch (err) {
      console.error('Erro ao consultar saldo:', err.message);
    }
  }, 3000); // Consulta a cada 5 segundos
};

const processarPagamento = async (externalId) => {
  try {
    console.log(`🚀 Iniciando DoTransaction para ExternalId: ${externalId}`);
    setMessage('✅ Pagamento confirmado. Coletando produto...');

    const response = await axios.post('https://pdvapi.giffi.com.br/api/processar-pagamento', {
      productOptionCode,
      quantity,
      value,
      txId: externalId,
      amountOverride: amountAquipaga
    });

    // 🔍 Verifica todas as formas possíveis de retorno de código
    const codigo =
      response.data?.codigoResgate ||
      response.data?.PaymentResultData?.Reference ||
      response.data?.PaymentResultData?.Observations ||
      null;

    if (codigo) {
      setCodigoResgate(codigo);
      setMessage('🎁 Código de resgate gerado.');

      // 📧 Enviar e-mail
      await enviarEmailTransacional(nomeProdutoSelecionado, codigo, externalId, emailCliente);
    } else {
      setMessage('Erro ao processar pagamento.');
      console.error('Erro: Código de resgate não encontrado na resposta da API.');
    }
  } catch (error) {
    console.error('Erro ao processar pagamento:', error);
    setMessage('Erro ao processar pagamento.');
  }
};

const productOptions = products.map(product => {
    // 🛠️ Correção: Verifica se o preço é válido
    const precoProduto = parseFloat(product.price);

    if (!isNaN(precoProduto) && precoProduto > 0) {
        console.log(`💰 Produto carregado: ${product.name} - Preço: R$ ${precoProduto}`);
        return {
            value: product.id,
            label: `${product.name} - R$ ${parseFloat(product.price).toFixed(2)}`,
            productOptionCode: product.productOptionCode || "Não encontrado"
        };
    } else {
        console.warn(`⚠️ Produto '${product.name}' não possui um valor válido.`);
        return null;
    }
}).filter(Boolean); // Remove produtos nulos

const { darkMode, toggleTheme } = useTheme(); // 🔥 Pega os estados do tema

return (
  <div className={`container-fluid ${darkMode ? "dark-mode" : "light-mode"}`}>
    <Row>
      {/* Coluna Esquerda */}
      <Col md={pixCode ? 6 : 12} className="px-4 d-flex align-items-center justify-content-center" style={{ paddingTop: '0.025rem' }}>
  <div style={{ maxWidth: '500px', width: '100%', marginTop: '0' }}>
    
    {/* Linha com logo à esquerda e botão à direita */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <a href="https://app.giffi.com.br" target="_blank" rel="noopener noreferrer">
        <img 
          src={darkMode ? logoDark : logo} 
          alt="Giffi Logo" 
          style={{ width: '105px', cursor: 'pointer' }} 
        />
      </a>

      <div className="d-flex flex-column align-items-end gap-2">
        {!logado && (
          <div className="d-flex gap-2">
            <button
              onClick={() => setExibirLogin(true)}
              className="btn"
              style={{
                backgroundColor: '#0d6efd',
                color: '#fff',
                fontSize: '0.75rem',
                padding: '4px 10px'
              }}
            >
              Login Lojista
            </button>

            <button 
              onClick={toggleTheme} 
              className={`btn ${darkMode ? 'btn-light' : 'btn-dark'}`}
              style={{ fontSize: '0.75rem', padding: '4px 10px' }}
            >
              {darkMode ? "Modo Claro" : "Modo Escuro"}
            </button>
          </div>
        )}

        {logado && (
          <>
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: '0.75rem', color: darkMode ? '#fff' : '#000' }}>
                Olá, <b>{usuario}</b>
              </span>
              <button
                onClick={() => {
                  setLogado(false);
                  setUsuario('');
                }}
                className={`btn ${darkMode ? 'btn-light' : 'btn-dark'}`}
                style={{ fontSize: '0.75rem', padding: '4px 10px' }}
              >
                Sair
              </button>
            </div>

            <button
              onClick={toggleTheme}
              className={`btn ${darkMode ? 'btn-light' : 'btn-dark'}`}
              style={{ fontSize: '0.75rem', padding: '4px 10px' }}
            >
              {darkMode ? "Modo Claro" : "Modo Escuro"}
            </button>
          </>
        )}
      </div>
      </div>

    <Modal show={exibirLogin && !logado} onHide={() => setExibirLogin(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Login Lojista</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              const login = e.target.login.value;
              const senha = e.target.senha.value;
              if (usuariosPermitidos[login] === senha) {
                setLogado(true);
                setExibirLogin(false);
                setUsuario(login);
              } else {
                alert("Usuário ou senha incorretos.");
              }
            }}
          >
            <Form.Group className="mb-3">
              <Form.Label>Usuário</Form.Label>
              <Form.Control name="login" type="text" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Senha</Form.Label>
              <Form.Control name="senha" type="password" required />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => setExibirLogin(false)}>Cancelar</Button>
              <Button variant="primary" type="submit">Entrar</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {!pixCode && (
                      <div className="text-center mb-4">
                        <p style={{ color: darkMode ? '#cccccc' : '#333333', fontSize: '0.80rem' }}>
                          Este é um ambiente dinâmico da <b>Giffi</b> para compras rápidas dos seus gift cards. Todos os produtos possuem um pequeno desconto. Visite <a href="https://giffi.com.br" target="_blank" rel="noopener noreferrer" style={{ color: darkMode ? '#66ccff' : '#007bff', textDecoration: 'none' }}><b>giffi.com.br</b></a> para obter a experiência completa. 😁
                        </p>
                      </div>
                    )}         

          <Card>
            <Card.Body>
              <h1>fast.buy 🚀</h1>      
              <Form.Group className="mb-3">
                <Form.Label>Produto</Form.Label>

                <Select
                    options={products.map(product => ({
                    value: product.id,
                    label: product.name,
                    image: product.image,
                    productOptionCode: product.productOptionCode || "Não encontrado"
                  }))}
                  components={{ 
                    Option: OptionWithImage,
                    SingleValue: SingleValueWithImage
                  }}
                  filterOption={(option, inputValue) => {
                    const normalizeText = (text) => {
                      return text
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "") // remove acentos
                        .replace(/r\$|\breais?\b/gi, "") // remove R$ e Reais
                        .replace(/[^a-zA-Z0-9]/g, "")   // remove símbolos
                        .toLowerCase()
                        .trim();
                    };

                    const normalizedLabel = normalizeText(option.label);
                    const normalizedInput = normalizeText(inputValue);
                    return normalizedLabel.includes(normalizedInput);
                  }}
                  styles={{
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? (darkMode ? '#444' : '#f0f0f0')
                        : (darkMode ? '#333333' : '#ffffff'),
                      color: state.isFocused
                        ? (darkMode ? '#ffffff' : '#000000')
                        : (darkMode ? '#e0e0e0' : '#000000'),
                    }),
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: darkMode ? '#333333' : '#ffffff',
                      color: darkMode ? '#ffffff' : '#000000',
                      borderColor: darkMode ? '#555555' : '#cccccc',
                      boxShadow: "none",
                      '&:hover': {
                        borderColor: darkMode ? '#777777' : '#aaaaaa'
                      }
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: darkMode ? '#ffffff' : '#000000',
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: darkMode ? '#ffffff' : '#000000',
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: darkMode ? '#aaaaaa' : '#888888',
                      fontSize: '0.75rem', // ⬅️ Ajuste de tamanho do placeholder
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: darkMode ? '#333333' : '#ffffff',
                    })
                  }}
                  onChange={(selectedOption) => {
                  const produto = products.find(p => p.id === selectedOption.value);
                  if (produto) {
                    // 🧠 Aqui usamos o PRICE como base para o QR Code e verificação
                    const precoExibido = parseFloat(produto.price);
                    setValue(precoExibido.toFixed(2)); // Esse valor será usado no QR code

                    // Salvamos o valor real (amount) num campo separado, para uso posterior no DoTransaction
                    setAmountAquipaga(
                      produto.amount && !isNaN(parseFloat(produto.amount))
                        ? parseFloat(produto.amount)
                        : null
                    );

                    setNomeProdutoSelecionado(produto.name);
                    setProductOptionCode(
                      selectedOption.productOptionCode !== "Não encontrado"
                        ? selectedOption.productOptionCode
                        : "Não encontrado"
                    );
                    setSelectedProduct(produto); // ✅ isso é o que alimenta o botão
                    setSelectedOption(selectedOption); // 👈 aqui está a linha-chave!
                    setProductCode(produto.id); // opcional: manter código atualizado
                  }
                }}
                  placeholder="Busque por Google Play, Uber, Rappi..."
                />
              <br></br>
              <Form.Label>E-mail</Form.Label>
                <Form.Control
                  type="email"
                  value={emailCliente}
                  placeholder="Informar um e-mail é opcional"
                  onChange={(e) => setEmailCliente(e.target.value)}
                  style={{
                    backgroundColor: darkMode ? '#333333' : '#ffffff',
                    color: darkMode ? '#ffffff' : '#000000',
                    borderColor: darkMode ? '#555555' : '#cccccc'
                  }}
                />

              </Form.Group>
              <div className="d-flex gap-2">
              {logado && (
                <Button
                  onClick={async () => {
                    try {
                      if (!selectedProduct) {
                        alert("Selecione um produto para continuar.");
                        return;
                      }

                      setMessage("⏳ Compra efetuada, aguardando emissão do código...");
                      setLoading(true);
                      setCodigoResgate(null);

                      const response = await axios.post('https://pdvapi.giffi.com.br/api/compra-direta', {
                        product_option_code: selectedProduct.productOptionCode,
                        amount: selectedProduct.amount
                      });

                      console.log("🔍 Resposta Compra Direta:", response.data);

                      if (response.data.codigo) {
                        setCodigoResgate(response.data.codigo);
                        setMessage(`🎁 Código de resgate gerado com sucesso: ${response.data.codigo}`);

                        console.log("📧 Enviando e-mail transacional para Compra Direta (logado)");

                        await enviarEmailTransacional(
                          selectedProduct.name,
                          response.data.codigo,
                          null,
                          `🛍️ #app-giffi | Compra direta Lojista finalizada: ${selectedProduct.name}`
                        );
                      }

                    } catch (err) {
                      console.error('❌ Erro ao realizar Compra Direta:', err.response?.data || err);
                      setMessage(`❌ Erro ao realizar Compra Direta: ${err.response?.data?.erro || 'erro desconhecido'}`);
                    }
                    finally {
                      setLoading(false);
                    }
                  }}
                  style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1' }}
                >
                  Compra Direta
                </Button>
              )}
              <Button
                onClick={handlePurchase}
                disabled={loading}
                style={{ backgroundColor: '#e83e8c', borderColor: '#e83e8c', color: '#fff' }}
              >
                {loading ? 'Processando...' : 'Gerar QR Code PIX'}
              </Button>
            </div>
              {message && (
                <p className={`mt-3 d-flex align-items-center gap-2 ${qrCodeExpirado ? 'text-danger' : 'text-success'}`}>
                  {message.includes('Aguardando pagamento') && !qrCodeExpirado && (
                    <Spinner animation="border" size="sm" role="status" />
                  )}
                  {qrCodeExpirado
                  ? '⛔ QR Code expirado. A página será recarregada em 10 segundos.'
                  : `${message}${(message.includes('Aguardando pagamento') && tempoRestante !== null)
                      ? ` (${Math.floor(tempoRestante / 60)}:${String(tempoRestante % 60).padStart(2, '0')})`
                      : ''}`}
                </p>
              )}
            </Card.Body>

            <footer
            style={{
              textAlign: 'center',
              fontSize: '0.60rem',
              color: darkMode ? '#aaa' : '#555',
              padding: '1rem',
              marginTop: '0rem'
            }}
          >
            © 2022-2025 <b>RP Serviços de Tecnologia ME</b>.
            Todos os pagamentos através do PIX são realizados à empresa <b>Ubiqfy Ltda</b>, sob o CNPJ 28.734.253/0001-08.
            Todos os produtos estão sujeitos à disponibilidade de estoque. Entre em contato através do canal oficial de atendimento da loja para mais informações: contato@giffi.com.br.
          </footer>
          </Card>
          
          <br></br>
         </div>
      </Col>
 
      {/* Coluna Direita - Desktop */}
      {pixCode && (
  <Col
    md={6}
    className="d-none d-md-flex align-items-center justify-content-center"
  >
    <div style={{ maxWidth: '500px', width: '100%', padding: '1rem' }}>
      <Card>
        <Card.Body>
          <div className="mt-3">
            <h2>PIX QR Code</h2>
            <div className="d-flex align-items-center mb-3">
              <QRCodeCanvas value={pixCode} size={300} includeMargin={true} />
            </div>

            <h2>PIX Copia e Cola</h2>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={pixCode}
                readOnly
              />
              <Button
                variant="secondary"
                onClick={() => navigator.clipboard.writeText(pixCode)}
                style={{ backgroundColor: '#00B89F', borderColor: '#00B89F' }}
              >
                Copiar
              </Button>
            </div>

            {codigoResgate && (
              <div className="mt-4">
                <h3>Código de Resgate</h3>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={codigoResgate}
                    readOnly
                  />
                  <Button
                    variant="secondary"
                    onClick={() => navigator.clipboard.writeText(codigoResgate)}
                  >
                    Copiar
                  </Button>
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <img
                src={seloSeguro}
                alt="Site 100% Seguro"
                style={{ height: '40px', objectFit: 'contain' }}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  </Col>
)}

      {/* Coluna Direita - Mobile */}
      {pixCode && (
  <Col xs={12} className="d-flex d-md-none justify-content-center mt-4">
    <div style={{ maxWidth: '500px', width: '100%', padding: '1rem' }}>
      <Card>
        <Card.Body>
          <div className="mt-3">
            <h2>PIX Copia e Cola</h2>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={pixCode}
                readOnly
              />
              <Button
                variant="secondary"
                onClick={() => navigator.clipboard.writeText(pixCode)}
                style={{ backgroundColor: '#00B89F', borderColor: '#00B89F' }}
              >
                Copiar
              </Button>
            </div>

            {codigoResgate && (
              <div className="mt-4">
                <h3>Código de Resgate:</h3>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={codigoResgate}
                    readOnly
                  />
                  <Button
                    variant="secondary"
                    onClick={() =>
                      navigator.clipboard.writeText(codigoResgate)
                    }
                  >
                    Copiar
                  </Button>
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <img
                src={seloSeguro}
                alt="Site 100% Seguro"
                style={{ height: '40px', objectFit: 'contain' }}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  </Col>
)}
    </Row>
   </div>
 
   
);
};

export default PDVApp;
